import { Box, Button, InputLabel, Input, MenuItem, Select } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import Header from '../../components/global/Header';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { Formik } from 'formik';
import * as yup from 'yup';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
axios.defaults.withCredentials = true;

const AddListing = () => {
  const successNotification = (message) => toast.success(message);
  const errorNotification = (message) => toast.error(message);
  const isNoneMobile = useMediaQuery('(min-width:600px)');
  const history = useNavigate();
  const [images, setImages] = useState();
  const [coverImage, setCoverImage] = useState();

  const initialValues = {
    listingTitle: '',
    price: '',
    listingDetails: '',
    propertyType: '',
    propertyClass: '',
    offerType: '',
    bedrooms: '',
    bathrooms: '',
    propertySize: '',
    neighborhood: '',
    city: '',
    country: '',
    features: '',
    qty: '',
  };

  const validationSchema = yup.object().shape({
    listingTitle: yup.string().required('This field is required'),
    price: yup.string().required('This field is required'),
    listingDetails: yup.string().required('This field is required'),
    propertyType: yup.string().required('This field is required'),
    propertyClass: yup.string().required('This field is required'),
    offerType: yup.string().required('This field is required'),
    bedrooms: yup.string().required('This field is required'),
    bathrooms: yup.string().required('This field is required'),
    propertySize: yup.string().required('This field is required'),
    neighborhood: yup.string().required('This field is required'),
    city: yup.string().required('This field is required'),
    country: yup.string().required('This field is required'),
    features: yup.string().required('This field is required'),
    qty: yup.string().required('This field is required'),
  });

  const handleImagesChange = (e) => {
    setImages(e.target.files);
  };
  const handleProjectCoverImageChange = (e) => {
    setCoverImage(e.target.files[0]);
  };

  const handleSubmit = (values) => {
    const formData = new FormData();
    for (let i = 0; i < images.length; i++) {
      formData.append(`images`, images[i]);
    }
    formData.append('coverImage', coverImage);
    formData.append('listingTitle', values.listingTitle);
    formData.append('price', values.price);
    formData.append('listingDetails', values.listingDetails);
    formData.append('propertyType', values.propertyType);
    formData.append('propertyClass', values.propertyClass);
    formData.append('offerType', values.offerType);
    formData.append('bedrooms', values.bedrooms);
    formData.append('bathrooms', values.bathrooms);
    formData.append('propertySize', values.propertySize);
    formData.append('neighborhood', values.neighborhood);
    formData.append('city', values.city);
    formData.append('country', values.country);
    formData.append('features', values.features);
    formData.append('address', values.address);
    formData.append('qty', values.qty);

    console.log(...formData);
    axios
      .post(`${process.env.REACT_APP_API_URL}/listings/post-listing`, formData, {
        withCredentials: true,
      })
      .then((res) => {
        console.log('response data', res.data);
        if (res.status === 200) {
          successNotification(res.data.message);
          setTimeout(() => {
            history('/shop-listings');
          }, 1500);
        } else {
          errorNotification(res.data.message);
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <Box m="20px">
        <Box>
          <Header
            title="ADD PROPERTY FOR SALE"
            subtitle="Add a Item to the Shopping Page on the frontend"
          />
        </Box>
        <Formik
          onSubmit={handleSubmit}
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
            <form encType="multipart/form-data" onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(6, minmax(0, 1fr))"
                sx={{
                  '& > div': {
                    gridColumn: isNoneMobile ? undefined : 'span 6',
                  },
                }}
                m="40px 0 0 0"
              >
                <Box sx={{ gridColumn: 'span 3' }}>
                  <InputLabel id="listingTitle">Listing Title</InputLabel>
                  <Input
                    fullWidth
                    type="text"
                    onChange={handleChange}
                    name="listingTitle"
                    value={values.listingTitle}
                    error={!!touched.listingTitle && !!errors.listingTitle}
                    helperText={touched.listingTitle && errors.listingTitle}
                    onBlur={handleBlur}
                  />
                </Box>

                <Box sx={{ gridColumn: 'span 2' }}>
                  <InputLabel id="price">Listing Price</InputLabel>
                  <Input
                    fullWidth
                    type="number"
                    onChange={handleChange}
                    name="price"
                    value={values.price}
                    error={!!touched.price && !!errors.price}
                    helperText={touched.price && errors.price}
                    onBlur={handleBlur}
                  />
                </Box>
                <Box sx={{ gridColumn: 'span 1' }}>
                  <InputLabel id="price">QTY Available</InputLabel>
                  <Input
                    fullWidth
                    type="number"
                    onChange={handleChange}
                    name="qty"
                    value={values.qty}
                    error={!!touched.qty && !!errors.qty}
                    helperText={touched.qty && errors.qty}
                    onBlur={handleBlur}
                  />
                </Box>

                <Box sx={{ gridColumn: 'span 6' }}>
                  <InputLabel id="listingDetails">Listing Details</InputLabel>
                  <Input
                    labelid="listingDetails"
                    fullWidth
                    variant="filled"
                    type="text"
                    multiline
                    rows="3"
                    onChange={handleChange}
                    name="listingDetails"
                    sx={{ gridColumn: 'span 2' }}
                    value={values.listingDetails}
                    error={!!touched.listingDetails && !!errors.listingDetails}
                    helperText={touched.status && errors.status}
                    onBlur={handleBlur}
                  />
                </Box>

                <Box sx={{ gridColumn: 'span 2' }}>
                  <InputLabel id="price">Property Size</InputLabel>
                  <Input
                    fullWidth
                    type="number"
                    onChange={handleChange}
                    name="propertySize"
                    value={values.propertySize}
                    error={!!touched.propertySize && !!errors.propertySize}
                    helperText={touched.propertySize && errors.propertySize}
                    onBlur={handleBlur}
                  />
                </Box>

                <Box
                  sx={{
                    gridColumn: 'span 2',
                    backgroundColor: 'transparent',
                    position: 'relative',
                  }}
                >
                  <InputLabel id="select">Property Type</InputLabel>
                  <Select
                    fullWidth
                    variant="filled"
                    labelId="select"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.propertyType}
                    name="propertyType"
                    error={!!touched.propertyType && !!errors.propertyType}
                    sx={{
                      backgroundColor: 'transparent',
                      position: 'absolute',
                      zIndex: '111',
                      top: '0px',
                      height: '50px',
                    }}
                  >
                    <MenuItem>Select Type</MenuItem>
                    <MenuItem value="House">House</MenuItem>
                    <MenuItem value="Land">Land</MenuItem>
                    <MenuItem value="Shop">Shop</MenuItem>
                    <MenuItem value="Mall">Mall</MenuItem>
                    <MenuItem value="Store">Store</MenuItem>
                    <MenuItem value="Warehouse">Warehouse</MenuItem>
                    <MenuItem value="Office Space">Office Space</MenuItem>
                  </Select>
                </Box>

                <Box
                  sx={{
                    gridColumn: 'span 2',
                    backgroundColor: 'transparent',
                    position: 'relative',
                  }}
                >
                  <InputLabel id="price">Property Class</InputLabel>
                  <Select
                    fullWidth
                    variant="filled"
                    labelId="select"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.propertyClass}
                    name="propertyClass"
                    error={!!touched.propertyClass && !!errors.propertyClass}
                    sx={{
                      backgroundColor: 'transparent',
                      position: 'absolute',
                      zIndex: '111',
                      top: '0px',
                      height: '50px',
                    }}
                  >
                    <MenuItem>Select Property Class</MenuItem>
                    <MenuItem value="Luxury">Luxury</MenuItem>
                    <MenuItem value="Intermediate">Intermediate</MenuItem>
                    <MenuItem value="Developing">Developing</MenuItem>
                  </Select>
                </Box>

                <Box
                  sx={{
                    gridColumn: 'span 2',
                    backgroundColor: 'transparent',
                    position: 'relative',
                  }}
                >
                  <InputLabel id="price">Offer Type</InputLabel>
                  <Select
                    fullWidth
                    variant="filled"
                    labelId="select"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.offerType}
                    name="offerType"
                    error={!!touched.offerType && !!errors.offerType}
                    sx={{
                      backgroundColor: 'transparent',
                      position: 'absolute',
                      zIndex: '111',
                      top: '0px',
                      height: '50px',
                    }}
                  >
                    <MenuItem>Select Offer Type</MenuItem>
                    <MenuItem value="For Sale">For Sale</MenuItem>
                    <MenuItem value="For Lease">For Lease</MenuItem>
                    <MenuItem value="To Let">To Let</MenuItem>
                  </Select>
                </Box>

                <Box sx={{ gridColumn: 'span 2' }}>
                  <InputLabel id="price">Bedrooms</InputLabel>
                  <Input
                    fullWidth
                    type="number"
                    onChange={handleChange}
                    name="bedrooms"
                    value={values.bedrooms}
                    error={!!touched.bedrooms && !!errors.bedrooms}
                    helperText={touched.bedrooms && errors.bedrooms}
                    onBlur={handleBlur}
                  />
                </Box>

                <Box sx={{ gridColumn: 'span 2' }}>
                  <InputLabel id="price">Bathrooms</InputLabel>
                  <Input
                    fullWidth
                    type="number"
                    onChange={handleChange}
                    name="bathrooms"
                    value={values.bathrooms}
                    error={!!touched.bathrooms && !!errors.bathrooms}
                    helperText={touched.bathrooms && errors.bathrooms}
                    onBlur={handleBlur}
                  />
                </Box>

                <Box sx={{ gridColumn: 'span 6' }}>
                  <InputLabel id="address">Property Full Adress</InputLabel>
                  <Input
                    fullWidth
                    type="text"
                    multiline
                    rows="2"
                    onChange={handleChange}
                    name="address"
                    value={values.address}
                    error={!!touched.address && !!errors.address}
                    helperText={touched.address && errors.address}
                    onBlur={handleBlur}
                  />
                </Box>

                <Box sx={{ gridColumn: 'span 2' }}>
                  <InputLabel id="neighborhood">Neighborhood</InputLabel>
                  <Input
                    fullWidth
                    type="text"
                    onChange={handleChange}
                    name="neighborhood"
                    value={values.neighborhood}
                    error={!!touched.neighborhood && !!errors.neighborhood}
                    helperText={touched.neighborhood && errors.neighborhood}
                    onBlur={handleBlur}
                  />
                </Box>

                <Box sx={{ gridColumn: 'span 2' }}>
                  <InputLabel id="city">City</InputLabel>
                  <Input
                    fullWidth
                    type="text"
                    onChange={handleChange}
                    name="city"
                    value={values.city}
                    error={!!touched.city && !!errors.city}
                    helperText={touched.city && errors.city}
                    onBlur={handleBlur}
                  />
                </Box>

                <Box sx={{ gridColumn: 'span 2' }}>
                  <InputLabel id="country">Country</InputLabel>
                  <Input
                    fullWidth
                    type="text"
                    onChange={handleChange}
                    name="country"
                    value={values.country}
                    error={!!touched.country && !!errors.country}
                    helperText={touched.country && errors.country}
                    onBlur={handleBlur}
                  />
                </Box>

                <Box sx={{ gridColumn: 'span 6' }}>
                  <InputLabel id="features">Property Features (separate with comma)</InputLabel>
                  <Input
                    fullWidth
                    type="text"
                    multiline
                    rows="3"
                    onChange={handleChange}
                    name="features"
                    value={values.features}
                    error={!!touched.features && !!errors.features}
                    helperText={touched.features && errors.features}
                    onBlur={handleBlur}
                  />
                </Box>

                <Box sx={{ gridColumn: 'span 3' }}>
                  <InputLabel id="projectDetails">Cover Image</InputLabel>
                  <Input
                    fullWidth
                    variant="filled"
                    type="file"
                    label="Cover Image"
                    placeholder="Cover Image"
                    onChange={handleProjectCoverImageChange}
                    name="coverImage"
                    sx={{ gridColumn: 'span 2' }}
                    required
                  />
                </Box>

                <Box sx={{ gridColumn: 'span 3' }}>
                  <InputLabel id="projectDetails" sx={{ paddingBottom: '7px' }}>
                    More Property Images
                  </InputLabel>
                  <input
                    type="file"
                    name="images"
                    onChange={handleImagesChange}
                    multiple
                    required
                    style={{ borderBottom: '1px solid #eee', width: '100%' }}
                  />
                </Box>
              </Box>

              <Box display="flex" justifyContent="end" mt="20px">
                <Button
                  type="submit"
                  color="secondary"
                  variant="contained"
                  sx={{
                    fontSize: '16px',
                    fontWeight: '600',
                  }}
                >
                  Post Property for Sale
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    </>
  );
};

export default AddListing;
